// src/components/Atoms/WhatsAppBanner.jsx
import Icon from './Icon.jsx';
import { useTranslation } from 'react-i18next';

export default function WhatsAppBanner() {
  const { t } = useTranslation();

  const message = encodeURIComponent(t('navbar.whatsapp_message'));
  
  return ( 
    <div className="fixed bottom-6 md:bottom-[22%] right-4 md:right-[1.5%] z-50">
     <a
        href={`https://wa.me/573155381468?text=Hola,%20necesito%20informaci%C3%B3n%20sobre%20SAP`}
        target="_blank"
        rel="noopener noreferrer"
        className="
          w-14 h-14 md:w-20 md:h-20                    /* tamaño responsivo */
          bg-[#25D366]                                 /* verde WhatsApp */
          text-white
          rounded-full                                 /* círculo perfecto */
          flex items-center justify-center
          shadow-lg                                    /* sombra suave */
          hover:shadow-xl                              /* sombra al pasar el ratón */
          transition-all duration-300
          cursor-pointer
          hover:scale-105                              /* efecto hover */
        "
      >
        <Icon
          name="bi bi-whatsapp"
          size="2rem"
          className="flex-shrink-0 md:!text-[2.5rem]"
        />
      </a>
    </div>
  );
}
